import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers, withCtx as _withCtx, unref as _unref } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = { class: "d-flex justify-content-between" }
const _hoisted_3 = { class: "element-header" }
const _hoisted_4 = { class: "element-box" }
const _hoisted_5 = { class: "form-header mb-4" }
const _hoisted_6 = { class: "row align-items-center justify-content-end mt-3" }
const _hoisted_7 = {
  key: 1,
  class: "table-responsive overflow-auto pt-4"
}
const _hoisted_8 = { class: "table table-striped" }
const _hoisted_9 = { style: {"text-align":"right","padding-right":"30px","min-width":"150px"} }
const _hoisted_10 = { class: "text-end" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["onClick"]

import clientService from '@/api/Client';
import EmptyState from '@/components/EmptyState.vue';
import Loader from '@/components/Loader.vue';
import Modal from '@/components/modal/Modal.vue';
import ModalDelete from '@/components/modal/ModalDelete.vue';
import PageTemplate from '@/components/PageTemplate.vue';
import Pagination from '@/components/Pagination.vue';
import PerPage from '@/components/PerPage.vue';
import {CloseToast, ErrorToast, SuccessToast} from '@/components/VueToast';
// @ts-ignore
import {getClientDropdown} from '@/shared/dropdowns';
import Form from '@/views/App/Client/SubClient/Form.vue';
import Search from '@/views/App/Client/SubClient/Search.vue';
import {onMounted, ref, watch} from 'vue';
import {useI18n} from 'vue-i18n';
import {ISubClientFilters, ISubClientList} from "@/interfaces/Client/ISubClient";
import {IClientFilters} from "@/interfaces/Client/IClient";


export default /*@__PURE__*/_defineComponent({
  __name: 'List',
  setup(__props) {

const {t} = useI18n();
const filters = ref<ISubClientFilters>({
  name: '',
  clientId: '',
  sortBy: '',
  page: 1,
  limit: 10,
});

const subClients = ref<ISubClientList>();
const subClientId = ref<number | null>(null);
const clientDropdown = ref([]);
const isSearching = ref(false);
const showModalForm = ref(false);
const showModalDelete = ref(false);
const isLoaded = ref(false);
const submitForm = ref(false);

watch(submitForm, () => {
  showModalForm.value = false;
  showModalDelete.value = false;
  subClientId.value = null;
  getSubClients();
});

async function getSubClients(
    page: number | undefined = 1,
    perPage?: number,
    passedFilters?: IClientFilters
) {

  CloseToast();

  if (passedFilters) {
    isSearching.value = true;
  }
  const perPageRes = subClients.value?.pagination?.items_per_page;

  try {
    const {data} = await clientService.getSubClients({
      ...(passedFilters ? passedFilters : filters.value),
      page: page,
      limit: perPage ?? perPageRes!,
    });

    subClients.value = data;
    isSearching.value = false;
  } catch (error) {
    await ErrorToast(error);
    isSearching.value = false;
  }
}

function handleFormSubClient(id: number | null) {
  CloseToast();
  subClientId.value = id;
  showModalDelete.value = false;
  showModalForm.value = true;
}

function handleDeleteSubClient(id: number) {
  CloseToast();
  subClientId.value = id;
  showModalDelete.value = true;
  showModalForm.value = false;
}

async function confirmDeleteSubClient() {
  try {
    await clientService.deleteSubClient(subClientId.value!);

    filters.value.clientId = '';
    filters.value.name = '';
    showModalDelete.value = false;

    await getSubClients();
    SuccessToast(t('general.toasts.delete_success'));
  } catch (error) {
    await ErrorToast(error);
  }
}

onMounted(async () => {
  await Promise.all([
    getSubClients(),
    getClientDropdown(clientDropdown),
  ]);

  isLoaded.value = true;
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(PageTemplate, null, {
      default: _withCtx(() => [
        (!isLoaded.value)
          ? (_openBlock(), _createBlock(Loader, { key: 0 }))
          : (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("h6", _hoisted_3, _toDisplayString(_ctx.$t('sub_client.title')), 1)
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("h5", _hoisted_5, _toDisplayString(_ctx.$t('sub_client.list')), 1),
                _createVNode(Search, {
                  filters: filters.value,
                  loading: isSearching.value,
                  clientDropdown: clientDropdown.value,
                  onSearch: getSubClients
                }, null, 8, ["filters", "loading", "clientDropdown"]),
                _createVNode(PerPage, {
                  values: [10, 25, 50, 100],
                  "onUpdate:perPage": getSubClients
                }),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-outline-primary",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (handleFormSubClient(null)))
                  }, _toDisplayString(_ctx.$t('sub_client.create')), 1)
                ]),
                (!subClients.value?.data?.length)
                  ? (_openBlock(), _createBlock(EmptyState, {
                      key: 0,
                      icon: "fa-building",
                      title: "Keine Einträge gefunden",
                      subtitle: "Es wurden keine zugeordneten Jobcenter gefunden, die Ihren Suchkriterien entsprechen."
                    }))
                  : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createElementVNode("table", _hoisted_8, [
                        _createElementVNode("thead", null, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("th", null, _toDisplayString(_ctx.$t('general.name')), 1),
                            _createElementVNode("th", null, _toDisplayString(_ctx.$t('general.client')), 1),
                            _createElementVNode("th", _hoisted_9, _toDisplayString(_ctx.$t('general.actions')), 1)
                          ])
                        ]),
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subClients.value?.data, (subClient) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: subClient.id
                            }, [
                              _createElementVNode("td", null, _toDisplayString(subClient?.name), 1),
                              _createElementVNode("td", null, _toDisplayString(subClient?.parent?.name), 1),
                              _createElementVNode("td", _hoisted_10, [
                                _createElementVNode("button", {
                                  class: "btn btn-primary",
                                  onClick: _withModifiers(($event: any) => (handleFormSubClient(subClient.id!)), ["stop"])
                                }, [...(_cache[4] || (_cache[4] = [
                                  _createElementVNode("i", { class: "os-icon os-icon-edit" }, null, -1)
                                ]))], 8, _hoisted_11),
                                _createElementVNode("button", {
                                  class: "btn btn-danger ms-2",
                                  onClick: _withModifiers(($event: any) => (handleDeleteSubClient(subClient.id!)), ["stop"])
                                }, [...(_cache[5] || (_cache[5] = [
                                  _createElementVNode("i", { class: "os-icon os-icon-trash" }, null, -1)
                                ]))], 8, _hoisted_12)
                              ])
                            ]))
                          }), 128))
                        ])
                      ])
                    ])),
                (subClients.value?.pagination?.total_pages ?? 0 > 1)
                  ? (_openBlock(), _createBlock(Pagination, {
                      key: 2,
                      totalPages: subClients.value?.pagination?.total_pages,
                      currentPage: subClients.value?.pagination?.current_page,
                      totalItems: subClients.value?.pagination?.total_items,
                      perPage: subClients.value?.pagination?.items_per_page,
                      onPagechanged: getSubClients
                    }, null, 8, ["totalPages", "currentPage", "totalItems", "perPage"]))
                  : _createCommentVNode("", true)
              ])
            ])),
        _createVNode(Modal, {
          modelValue: showModalForm.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((showModalForm).value = $event)),
          title: "zugeordnete Jobcenter",
          "hide-cancel": true,
          "button-label": _ctx.$t('general.button.save'),
          sizeModal: "modal-xl",
          "hide-footer": true,
          classFooter: "justify-content-center"
        }, {
          default: _withCtx(() => [
            _createVNode(Form, {
              subClientId: subClientId.value,
              clientDropdown: clientDropdown.value,
              submitForm: submitForm.value,
              "onUpdate:submitForm": _cache[1] || (_cache[1] = ($event: any) => ((submitForm).value = $event))
            }, null, 8, ["subClientId", "clientDropdown", "submitForm"])
          ]),
          _: 1
        }, 8, ["modelValue", "button-label"])
      ]),
      _: 1
    }),
    _createVNode(ModalDelete, {
      modelValue: showModalDelete.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((showModalDelete).value = $event)),
      header: _unref(t)('general.delete_item_header'),
      onDelete: confirmDeleteSubClient
    }, null, 8, ["modelValue", "header"])
  ], 64))
}
}

})